export const widgetPositionValues = {
  'bottom-right-corner': {
    button: [
      ['bottom', '30px'],
      ['right', '30px'],
    ],
    helperMessages: [
      ['top', 'auto'],
      ['left', 'auto'],
      [
        ['border-top-left-radius', '20px'],
        ['border-top-right-radius', '20px'],
        ['border-bottom-left-radius', '20px'],
        ['border-bottom-right-radius', 'initial'],
      ],
    ],
    conversation: [
      ['right', '15px'],
      ['bottom', '15px'],
    ],
  },
  'bottom-left-corner': {
    button: [
      ['bottom', '30px'],
      ['left', '30px'],
    ],
    helperMessages: [
      ['top', 'auto'],
      ['right', 'auto'],
      [
        ['border-top-left-radius', '20px'],
        ['border-top-right-radius', '20px'],
        ['border-bottom-left-radius', 'initial'],
        ['border-bottom-right-radius', '20px'],
      ],
    ],
    conversation: [
      ['left', '15px'],
      ['bottom', '15px'],
    ],
  },
  'top-right-corner': {
    button: [
      ['top', '30px'],
      ['right', '30px'],
    ],
    helperMessages: [
      ['left', 'auto'],
      ['top', '100px'],
      [
        ['border-top-left-radius', '20px'],
        ['border-top-right-radius', 'initial'],
        ['border-bottom-left-radius', '20px'],
        ['border-bottom-right-radius', '20px'],
      ],
    ],
    conversation: [
      ['right', '15px'],
      ['top', '15px'],
    ],
  },
  'top-left-corner': {
    button: [
      ['top', '30px'],
      ['left', '30px'],
    ],
    helperMessages: [
      ['right', 'auto'],
      ['top', '100px'],
      [
        ['border-top-left-radius', 'initial'],
        ['border-top-right-radius', '20px'],
        ['border-bottom-left-radius', '20px'],
        ['border-bottom-right-radius', '20px'],
      ],
    ],
    conversation: [
      ['left', '15px'],
      ['top', '15px'],
    ],
  },
  // 'top-middle': [
  //   ['top', '30px'],
  //   ['left', '50%'],
  // ],
  // 'bottom-middle': [
  //   ['bottom', '30px'],
  //   ['left', '50%'],
  // ],
};
